/* eslint-disable quotes */
/* eslint-disable react/display-name */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { memo, useEffect, useState, useRef, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAuthSession, privateChatID } from "../Helpers/common";
import {
  setChatSearchState,
  setLoaderSearchChatMessage,
  setSearchChatData,
  setSearchedChatMessages,
} from "../redux/chatSlice";
import { _searchChatMessage } from "../../SocketIo";
import { alertMsg } from "../util/alertMsg";
import ChatboardSearchOutgoing from "./chatboardSearchOutgoing";
import ChatboardSearchIncoming from "./chatboardSearchIncoming";
import CustomChatLoader from "../customComponent/customChatLoader";

const ChatboardSearch = ({ handleJumpToMessage }) => {
  const inputRef = useRef();
  const dispatch = useDispatch();
  const authSession = getAuthSession();
  const [chatSearch, setChatSearch] = useState("");
  const chatFeedRef = useRef(null);

  const authSessionUser = useSelector(
    (state) => state.authUserDetail.authSessionUser,
  );
  const {
    attendeeData,
    sidebarActiveData,
    chatSearchState,
    loaderSearchChatMessage,
    searchedChatMessages,
  } = useSelector((state) => state.chat);

  let groupId = "";
  let senderID = authSession?.user_unique_key;
  if (attendeeData.type === "group") {
    groupId = attendeeData?.groupId;
  }

  let incomingUserObj = attendeeData;
  let outgoingUserObj = authSessionUser;

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const attendeeSearchText = (e) => {
    setChatSearch(e.target.value);
    if (e.target.value.trim() === "") {
      ClearSearchChat();
    }
  };

  const runSearch = (searchValue) => {
    const { user_unique_key, company_unique_key } = authSession;
    const documentID =
      attendeeData.type === "group"
        ? groupId
        : privateChatID([user_unique_key, attendeeData?.user_id]);

    if (!searchValue || searchValue.trim() === "") {
      ClearSearchChat();
      return;
    }

    const Payload = {
      user_id: user_unique_key,
      company_id: company_unique_key,
      documentID,
      filter: searchValue,
    };
    _searchChatMessage(Payload);
    dispatch(setLoaderSearchChatMessage(true));
  };

  const SearchChat = (e) => {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();

      const serach_id =
        attendeeData.type === "group" ? groupId : attendeeData?.user_id;

      if (chatSearch.trim() === "") {
        ClearSearchChat();
      } else {
        dispatch(setSearchChatData(chatSearch));
        runSearch(chatSearch);
      }

      dispatch(
        setChatSearchState({
          ...chatSearchState,
          [serach_id]: chatSearch,
        }),
      );
    }

    if (e.key === "Backspace" && e.target.value.length === 1) {
      ClearSearchChat();
    }
  };

  const ClearSearchChat = () => {
    const search_id =
      attendeeData.type === "group" ? groupId : attendeeData?.user_id;
    if (chatSearchState[search_id]) {
      let updatedSearchedChatText = { ...chatSearchState };
      delete updatedSearchedChatText[search_id];
      dispatch(setChatSearchState(updatedSearchedChatText));
    }
    setChatSearch("");
    dispatch(setSearchChatData(""));
    dispatch(setLoaderSearchChatMessage(false));
    dispatch(setSearchedChatMessages([]));
    inputRef.current?.focus();
  };

  useEffect(() => {
    const savedSearch = chatSearchState[sidebarActiveData];
    if (savedSearch && savedSearch !== "") {
      setChatSearch(savedSearch);
      runSearch(savedSearch);
    } else {
      setChatSearch("");
      ClearSearchChat();
    }
  }, [sidebarActiveData]);

  return (
    <div className="search">
      <div className="chat_search">
        <input
          ref={inputRef}
          spellCheck="false"
          value={chatSearch}
          type="text"
          className="form-control"
          placeholder="Type to search..."
          aria-label="Search chat"
          onKeyDown={SearchChat}
          onChange={attendeeSearchText}
        />
        {chatSearch ? (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            href="javascript:void(0);"
            className="btn_search icon_container"
            onClick={(e) => ClearSearchChat(e)}
          >
            <svg
              width="11.13"
              height="11.13"
              viewBox="0 0 9.13 9.13"
              className="rotate-45 cross"
            >
              <path
                fill="#b8c0c9"
                id="Icon_awesome-plus"
                d="M7.621,5.051H4.329V1.759A.509.509,0,0,0,3.82,1.25H3.311a.509.509,0,0,0-.509.509V5.051H-.491A.509.509,0,0,0-1,5.561V6.07a.509.509,0,0,0,.509.509H2.8V9.871a.509.509,0,0,0,.509.509H3.82a.509.509,0,0,0,.509-.509V6.579H7.621A.509.509,0,0,0,8.13,6.07V5.561A.509.509,0,0,0,7.621,5.051Z"
                transform="translate(1 -1.25)"
              ></path>
            </svg>
          </a>
        ) : (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a className="btn_search icon_container" href="javascript:void(0);">
            <svg width="13.807" height="13.807" viewBox="0 0 13.807 13.807">
              <g
                id="Icon_feather-search"
                data-name="Icon feather-search"
                transform="translate(-3.75 -3.75)"
              >
                <path
                  id="Path_1034"
                  data-name="Path 1034"
                  fill="none"
                  stroke="#b8c0c9"
                  d="M15.163,9.832A5.332,5.332,0,1,1,9.832,4.5a5.332,5.332,0,0,1,5.332,5.332Z"
                />
                <path
                  id="Path_1035"
                  data-name="Path 1035"
                  fill="none"
                  stroke="#b8c0c9"
                  d="M27.874,27.874l-2.9-2.9"
                  transform="translate(-11.378 -11.378)"
                />
              </g>
            </svg>
          </a>
        )}
      </div>
      <hr className="chat-search-hr" />
      <div
        className={`chat_box ${searchedChatMessages.length === 0 ? "" : ""}`}
      >
        <div>
          {loaderSearchChatMessage ? (
            <CustomChatLoader />
          ) : Object.keys(chatSearchState).length === 0 ? (
            <SearchedChatInitialMessage />
          ) : searchedChatMessages.length === 0 ? (
            <SearchedChatMessageNotFound />
          ) : (
            <div
              id="chat-feed"
              className={`chat-feed ${
                searchedChatMessages.length >= 3 ? "overflow-auto" : ""
              }`}
              ref={chatFeedRef}
            >
              <div>
                {searchedChatMessages.map((value, index) => (
                  <Fragment key={index}>
                    {value.senderID === senderID ? (
                      <ChatboardSearchOutgoing
                        value={value}
                        userInfo={outgoingUserObj}
                        lastMessage={searchedChatMessages.length - 1 === index}
                        chatSearch={chatSearch}
                        handleJumpToMessage={handleJumpToMessage}
                      />
                    ) : (
                      <ChatboardSearchIncoming
                        value={value}
                        userInfo={incomingUserObj}
                        lastMessage={searchedChatMessages.length - 1 === index}
                        chatSearch={chatSearch}
                        handleJumpToMessage={handleJumpToMessage}
                      />
                    )}
                  </Fragment>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(ChatboardSearch);

const SearchedChatMessageNotFound = () => {
  return (
    <p className="text-center pt-3">
      <b>{alertMsg.nothingSearch}</b>
      <br />
      {alertMsg.msgNotFound}
      <br />
    </p>
  );
};
const SearchedChatInitialMessage = () => {
  return (
    <p className="text-center">
      <b>{alertMsg.initialSearch}</b>
    </p>
  );
};
